{
  "defaultTitle": "Tidak dapat check-in",
  "defaultMessage": "Harap konfirmasi informasi dengan dispatcher Anda atau hubungi gudang",
  "backToHomescreen": "Kembali ke layar beranda",
  "hideErrorLog": "SEMBUNYIKAN LOG KESALAHAN",
  "viewErrorLog": "LIHAT LOG KESALAHAN",
  "errorLogMessageLabel": "Pesan:",
  "errorLogStatusLabel": "Kode Status:",
  "unknown": "Tidak diketahui"
}
